import { render, staticRenderFns } from "./MirrorHistoric.vue?vue&type=template&id=4a4f35ba&scoped=true&"
import script from "./MirrorHistoric.vue?vue&type=script&lang=js&"
export * from "./MirrorHistoric.vue?vue&type=script&lang=js&"
import style0 from "./MirrorHistoric.vue?vue&type=style&index=0&id=4a4f35ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4f35ba",
  null
  
)

export default component.exports